<template>
  <div class="export-project-rms">
    <export-steps :steps="steps" :current-step="stepIndex"></export-steps>
    <div class="step-container">
      <div class="popper-desc" v-if="stepIndex === 1 && exportStatus === 0">
        {{ $t("export_project.title_connected_robots") }}
      </div>
      <send-project-status
        style="margin-top: 25px"
        v-if="stepIndex === 0 && exportStatus === 4"
        :status-code="4"
        :status-config="sendStatusConfig"
      ></send-project-status>
      <device-list
        v-if="stepIndex === 1 && rmsGroups && exportStatus === 0"
        target="rms"
        :data="rmsGroups"
        :total-size="totalProjectSize"
        @select-device="onSelectDevice"
      ></device-list>
      <send-project-status
        style="margin-top: 25px"
        v-if="stepIndex !== 0 && exportStatus !== 0"
        :status-code="exportStatus"
        :progress="sendProgress"
        :status-config="sendStatusConfig"
      ></send-project-status>
    </div>
    <div class="footer">
      <template v-if="stepIndex === 0">
        <div></div>
        <div>
          <span
            class="export-pop-button gray line"
            v-if="currentVersion === 'teacher'"
            @click="$emit('change-target', 'quick')"
            >{{ $t("export_project.switch_quick") }}</span
          >
          <button
            v-if="stepIndex === 0"
            class="export-pop-button blue"
            :class="{ disabled: !canConnect }"
            @click="startConnect"
          >
            {{ $t("export_project.start_connect") }}
          </button>
        </div>
      </template>
      <template v-else-if="stepIndex === 1 && exportStatus === 0">
        <div>
          <div class="selected-device-count">
            {{
              $t("export_project.selected_device_count", {
                count: targetDevices.length,
              })
            }}
          </div>
          <div class="project-size">
            {{
              $t("export.project_size", {
                size: projectInfos[0] ? projectInfos[0].formatedSize : "...",
              })
            }}
          </div>
        </div>
        <div>
          <button class="export-pop-button gray" @click="$emit('close')">
            {{ $t("button.cancel") }}
          </button>
          <!-- <button class="export-pop-button gray" @click="closeRms">{{$t("button.cancel")}}</button> -->
          <button
            class="export-pop-button blue"
            :class="{ disabled: !hasProjectInfo || targetDevices.length === 0 }"
            @click="startExport"
          >
            {{ $t("export_project.start_export") }}
          </button>
        </div>
      </template>
      <template v-else-if="stepIndex === 2">
        <span class="find-project-tip">
          <span v-if="[1, 2].includes(exportStatus)">
            <el-tooltip
              popper-class="export-project-tooltip"
              placement="top-start"
            >
              <div class="toolti-content" slot="content">
                {{ $t("export_project.find_file_tip") }}
              </div>
              <span class="el-icon-warning-outline warn-trigger"></span>
            </el-tooltip>
            <span style="vertical-align: middle;font-size:12px;">
              {{ $t("export_project.cant_find_file") }}
            </span>
          </span>
        </span>
        <div v-if="[1, 2].includes(exportStatus)" style="text-align: right">
          <div
            class="backup-project export-pop-button gray line"
            @click="beforeBackupProject"
          >
            {{ $t("export_project.backup_project") }}
          </div>
          <br />
          <button class="export-pop-button gray" @click="$emit('close')">
            {{ $t("export_project.complate_export") }}
          </button>
        </div>
        <div v-if="exportStatus === 3">
          <button class="export-pop-button gray" @click="$emit('close')">
            {{ $t("button.cancel") }}
          </button>
          <button class="export-pop-button blue" @click="startExport">
            {{ $t("export_project.resend") }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import exportSteps from "./export-steps.vue"
import initSocketCicleMix from "@/code-lab/component/mixins/init-socket-cicle-mix.js"
import connectRequestMix from "@/code-lab/component/connection/connect-request-mix.js"
import mixFileManagement from "@/code-lab/component/file-management/mixins/mix-file-request-manage.js"
import sendProjectStatus from "./send-project-status.vue"
import deviceList from "./device-list.vue"
import config from "@/service/config.js"
import { mapState, mapActions } from "vuex"
import { closeQuick, closeRms, closeWhite } from "./close-connection"
const baseUrl$ = process.env.BASE_URL
export default {
  name: "export-project-rms",
  mixins: [initSocketCicleMix, mixFileManagement, connectRequestMix],
  components: {
    exportSteps,
    deviceList,
    sendProjectStatus,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      copyToRms: 1,
      steps: [
        {
          label: this.$t("export_project.step_1"),
        },
        {
          label: this.$t("export_project.step_2"),
        },
        {
          label: this.$t("export_project.step_3"),
        },
      ],
      stepIndex: 0,
      canConnect: true,
      connected: false,
      exportStatus: 4, //派发状态，0-沒開始派發，1-部分成功，2-全部成功，3-派发失败,4-还没连线
      projectInfos: [],
      targetDevices: [],
      sendProgress: 0,
      sendStatusConfig: {
        1: {
          title: this.$t("export_project.title_2"),
          message: (count) => {
            return this.$t("export_project.message_1_1", { count })
          },
          image: baseUrl$ + "static/images/send_status_2.png",
        },
        2: {
          title: this.$t("export_project.title_2"),
          message: (count) => {
            return this.$t("export_project.message_2_1", { count })
          },
          image: baseUrl$ + "static/images/send_status_2.png",
        },
        3: {
          title: this.$t("export_project.title_3"),
          message: this.$t("export_project.message_3"),
          image: baseUrl$ + "static/images/send_status_3.png",
        },
        4: {
          title: this.$t("export_project.title_4"),
          message: this.$t("export_project.message_4"),
          image: baseUrl$ + "static/images/send_status_4.png",
        },
        5: {
          title: this.$t("export_project.title_5"),
          message: (count) => {
            return this.$t("export_project.message_5_1", { count })
          },
          image: baseUrl$ + "static/images/send_status_1.png",
        },
      },
    }
  },
  computed: {
    ...mapState('user', [
        'teamId',
        'token'
    ]),
    ...mapState(["currentVersion", "connectGolbalState"]),
    ...mapState("rmsConnection", ["connectDevices", "rmsGroups"]),
    hasProjectInfo() {
      return (
        this.projectInfos.length === this.data.length &&
        this.projectInfos.length > 0
      )
    },
    totalProjectSize() {
      let size = 0
      this.projectInfos.forEach((item) => (size += item.size))
      return size
    },
  },
  watch: {
    connected(value) {
      if (value) {
        this.getAllDevices()
      }
    },
    connectGolbalState(value, oldValue) {
      if ([2, 3].includes( oldValue )) {
        return
      }
      console.log("connect global state change:", value)
      if (value === 1) {
        this.connected = true
        this.exportStatus = 0
        this.stepIndex = 1
      } else {
        this.connected = false
        this.exportStatus = 4
        this.stepIndex = 0
      }
    },
  },
  created() {
    this.projectInfos = []
    this.data.forEach((project) => {
      this.getProjectUrl(project.projectId, (res) => {
        this.projectInfos.push(Object.assign(res, { name: project.name }))
      })
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.checkConnection()
    })
  },
  methods: {
    ...mapActions("quickConnection", ["getRobotInfo"]),
    closeQuick,
    closeRms,
    closeWhite,
    checkConnection() {
      if (this.connectGolbalState === 1) {
        this.connected = true
        this.exportStatus = 0
        this.stepIndex = 1
      } else {
        this.connected = false
        this.exportStatus = 4
        this.stepIndex = 0
      }
    },
    async startConnect() {
      if (this.connected) {
        this.stepIndex = 1
        this.exportStatus = 0
        await this.getAllDevices()
      } else {
        if ([2, 3].includes( this.connectGolbalState )) {
          console.log("关闭quick连线")
          this.closeQuick()
          this.closeWhite()
        }
        if (!this.b$.rms) {
          await this.initRmsSocket()
        }
        await this.handleConnect()
      }
    },
    async handleConnect() {
      const { webSocketProtocol, rmsConnectionWebsocketUrl } = config
      const host = webSocketProtocol + rmsConnectionWebsocketUrl
      const url = host + "?sessionToken=" + this.token
      await this.b$.start("rms", url, "ws.open", this.handleOpenEvent)
    },
    async handleOpenEvent() {
      await this.b$.send("rms", { cmd: "web_login", data: {} }, async () => {
        await this.b$.assignment("rms", { store: {} })
        const { teamId } = await this.func$.getUserInfo$("rms_user")
        await this.b$.assignment("rms", { customerid: teamId }, "store")
        this.$store.commit("handleConnectGolbalState", 1)
      })
    },
    async getAllDevices() {
      this.http$(
        "get",
        "/rms/groups",
        {
          limit: 0,
          page: 1,
        },
        null,
        {
          Authorization: "Bearer " + this.token,
          customerid: this.teamId,
        }
      )
        .then((res) => {
          if (res.data.data.payload) {
            const groupData = res.data.data.payload.map((group) => {
              const devices = (group.devices || []).filter(
                (device) => !!device.robotInfo && !!device.robotInfo.freeMemory
              )
              return {
                groupId: group.groupId,
                name: group.groupName,
                deviceCount: devices.length,
                devices: devices.map((device) => {
                  return {
                    deviceId: device.deviceId,
                    sn: device.sn,
                    clientId: device.clientId,
                    clientName: device.name,
                    isOnline: Number(device.connState) === 2,
                    freeMemory: device.robotInfo.freeMemory,
                    imageVer: device.robotInfo.imageVer,
                    isDeploy: device.deployMicroCoding,
                    connState: device.connState,
                  }
                }),
              }
            })
            console.log(groupData, "groupData")
            this.$store.commit("rmsConnection/setRmsGroups", groupData)
          } else {
            this.$store.commit("rmsConnection/setRmsGroups", [])
          }
        })
        .catch((err) => {
          console.error("get rms group error:", err)
          this.$store.commit("rmsConnection/setRmsGroups", [])
        })
    },
    getProjectUrl(projectId, callback = () => {}) {
      this.export_execute_file$(
        (res) => {
          if (
            ![
              "task_creating",
              "task_created",
              "task_finished"
            ].includes(res.data.state)
          ) {
            this.getProjectInfoError = true
          } else if (res.data.state === "task_finished") {
            const { projectId, url, size } = res.data
            callback({
              projectId,
              url,
              size,
              formatedSize: this.util$.diskSize$(size, "MB"),
            })
          }
        },
        { projectId }
      )
    },
    onSelectDevice(devices) {
      this.targetDevices = devices
    },
    computedProgress(list) {
      return (
        (list.reduce((pre, nxt) => (pre += nxt.progress / 100), 0) /
          list.length) *
        100
      )
    },
    startExport() {
      if (!this.hasProjectInfo || this.targetDevices.length === 0) {
        return
      }
      const { url, name: destinationName, size } = this.projectInfos[0]
      const to = this.targetDevices
      this.exportStatus = 0
      this.stepIndex = 1
      this.sendProgress = 0
      this.sendFileList = []
      this.b$.send(
        "rms",
        {
          cmd: "set_code_install",
          data: {
            destinationName,
            url,
            size,
            from: "server",
            to,
          },
        },
        (res) => {
          console.log("set_code_install:", res)
          if (res.cmd === "code_install_response") {
            console.log("code_install_response:", res)
            if (typeof res.data.result === "boolean") {
              const target = this.sendFileList.find(
                (item) => item.clientId === res.data.from
              )
              if (target) {
                target.result = res.data.result
              }
              if (
                this.sendFileList.every(
                  (item) => typeof item.result === "boolean"
                ) &&
                to.length === this.sendFileList.length
              ) {
                if (this.sendFileList.every((item) => !!item.result)) {
                  // this.sendProgress = this.sendFileList.length
                  this.exportStatus = 2
                } else if (this.sendFileList.every((item) => !item.result)) {
                  // this.sendProgress = this.sendFileList.length
                  this.exportStatus = 3
                } else {
                  this.exportStatus = 1
                }
                this.sendProgress = this.sendFileList.filter(
                  (item) => item.result
                ).length
              }
              console.log(this.sendFileList, "this.sendFileList")
            }
          }
          if (res.cmd === "code_install_progress") {
            console.log("code_install_progress:", res)
            const target = this.sendFileList.find(
              (item) => item.clientId === res.data.from
            )
            if (target) {
              target.progress = res.data.progress
            }
            this.sendProgress = this.computedProgress(this.sendFileList)
            this.exportStatus = 5
          }

          if (res.cmd === "set_code_install") {
            if (res.data?.list) {
              this.sendFileList = res.data.list.filter((item) =>
                /^0-/.test(item.clientId)
              )
              if (
                this.sendFileList.some(
                  (o) => o.status === "active" || o.connState > 0
                )
              ) {
                this.sendFileList.forEach((item) => (item.progress = 0))
                this.sendProgress = 0
                this.exportStatus = 5
              } else {
                this.exportStatus = 3
              }
              this.stepIndex = 2
            }
          }
        }
      )
    },
    beforeBackupProject() {
      this.$confirm(
        this.$t("export_project.backup_project_message"),
        this.$t("export_project.backup_project_title"),
        {
          closeOnPressEscape: false,
          cancelButtonClass: "export-pop-button gray",
          confirmButtonClass: "export-pop-button  blue",
          cancelButtonText: this.$t("button.cancel"),
          confirmButtonText: this.$t("export_project.confirm_backup"),
          customClass: "export-excute-popper",
          destroyOnClose: true,
        }
      )
        .then(() => {
          this.backupProject()
        })
        .catch(() => {})
    },
    async backupProject(forceOverwrite = {}) {
      let body = {
        projectId: this.projectInfos[0].projectId,
        url: this.projectInfos[0].url,
        type: "codeLab",
        ...forceOverwrite,
      }
      if (this.copyToRmsLoading) return
      this.copyToRmsLoading = true
      const [, error] = await this.http$(
        "post",
        "/rms/upload/to/rms",
        null,
        body,
        {
          Authorization: "Bearer " + this.token,
          customerid: this.teamId,
        }
      )
        .then((res) => {
          return [res, null]
        })
        .catch((err) => {
          console.log("error:", err)
          return [null, err]
        })

      this.copyToRmsLoading = false
      if (error) {
        if (this.copyToRms === 1) {
          const response = error.response
          if (
            response &&
            response.data &&
            response.data.status &&
            response.data.status.description.indexOf("data exist") > -1
          ) {
            this.$confirm(
              "檔案已存在, 繼續將覆蓋已經存在的檔案, 是否继续?",
              "重複專案提示",
              {
                confirmButtonText: "確定覆蓋",
                cancelButtonText: "新增專案",
                distinguishCancelAndClose: true,
              }
            )
              .then(() => {
                this.backupProject({ forceOverwrite: "Y" })
                console.log("覆蓋檔案")
              })
              .catch((err) => {
                console.log(err, response)
                if (err === "cancel") {
                  const newProjectName = response.data.status.message
                  this.backupProject({
                    forceAdd: "Y",
                    newProjectName: newProjectName,
                  })
                }
              })
            this.copyToRms = 2
          } else {
            if (this.copyToRms === 2) {
              if (forceOverwrite.forceAdd) {
                this.$message({
                  type: "error",
                  message: "新增專案失敗",
                })
              } else {
                this.$message({
                  type: "error",
                  message: "強制覆蓋專案失敗",
                })
              }
            } else {
              this.$message({
                type: "error",
                message: "備份失敗",
              })
            }
            this.copyToRms = 1
          }
        }
      } else {
        if (this.copyToRms === 1) {
          this.$message({
            type: "success",
            message: "備份成功",
          })
        }
        if (this.copyToRms === 2) {
          if (forceOverwrite.forceAdd) {
            this.$message({
              type: "success",
              message: "新增專案成功",
            })
          } else {
            this.$message({
              type: "success",
              message: "強制覆蓋專案成功",
            })
          }
        }
        this.copyToRms = 1
      }
    },
  },
}
</script>
<style lang="scss">
.export-project-rms {
  .popper-desc {
    font-size: 16px;
    color: #ffffff;
    padding: 18px 0;
  }
  .popper-title {
    font-size: 14px;
    color: #ffffff;
  }
  .step-container {
    width: 100%;
  }
  .footer {
    width: 100%;
    margin-top: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .vercode-tip {
      span {
        text-decoration: underline;
        font-size: 12px;
        color: #a8a8ac;
        &:hover {
          color: #0ed3ff;
        }
      }
    }
    .selected-device-count {
      font-size: 12px;
      color: #ffffff;
      padding-bottom: 8px;
    }
    .project-size {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 4px;
      background-color: rgba(168, 168, 172, 0.2);
      font-size: 12px;
      color: #ffffff;
    }
    .find-project-tip {
      color: #c8c8c8;
      margin-top: 32px;
      .warn-trigger {
        display: inline-block;
        font-size: 20px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        text-align: center;
        vertical-align: middle;
        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
}
</style>